
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireef48"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireef48"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $62603c3647efad22$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9vqfN","index.2c1f5326.js","b1AA7","menu-icon.c9211c75.svg","87Ion","menu-close.57b618ef.svg"]'));

// icons
var $cdaef6999f4cbbab$exports = {};
$cdaef6999f4cbbab$exports = new URL("menu-icon.c9211c75.svg", import.meta.url).toString();


var $24f414772ce0caad$exports = {};
$24f414772ce0caad$exports = new URL("menu-close.57b618ef.svg", import.meta.url).toString();


// Display year in the footer using Date
const $35da740d59af89ba$var$footerYear = document.getElementById("copyrightYear");
let $35da740d59af89ba$var$d = new Date();
$35da740d59af89ba$var$footerYear.textContent = $35da740d59af89ba$var$d.getFullYear();
// Navigation functionality
const $35da740d59af89ba$var$navToggleButton = document.getElementById("navToggleButton");
const $35da740d59af89ba$var$navBarLinks = document.getElementById("navbarLinks");
const $35da740d59af89ba$var$menuToggleIcon = document.querySelector("#menuToggleIcon");
let $35da740d59af89ba$var$hidden = true;
$35da740d59af89ba$var$navToggleButton.addEventListener("click", ()=>{
    if ($35da740d59af89ba$var$hidden) {
        // navToggleButton.classList.add("nav__toggle-focus");
        $35da740d59af89ba$var$navBarLinks.classList.add("nav__links-show");
        $35da740d59af89ba$var$menuToggleIcon.setAttribute("src", (0, (/*@__PURE__*/$parcel$interopDefault($24f414772ce0caad$exports))));
        $35da740d59af89ba$var$hidden = false;
    } else {
        // navToggleButton.classList.remove("nav__toggle-focus");
        $35da740d59af89ba$var$navBarLinks.classList.remove("nav__links-show");
        $35da740d59af89ba$var$menuToggleIcon.setAttribute("src", (0, (/*@__PURE__*/$parcel$interopDefault($cdaef6999f4cbbab$exports))));
        $35da740d59af89ba$var$hidden = true;
    }
});


//# sourceMappingURL=index.2c1f5326.js.map
